import Flex from "@/components/flex"
import useIsMobile from "@/hooks/use-is-mobile"
import { langStore } from "@/stores/lang-store"
import { trendBundle } from "./resource-trend-const"

const Desktop = ({ trends, item, lang }) => {
  return (
    <div className="mt-4 flex items-center justify-between">
      <Flex className="flex-col" gap={0}>
        <span className="text-xs text-gray-400">{trendBundle.minUsage[lang]}</span>

        <div className="mt-1 flex items-end gap-1">
          <span className="text-lg font-bold text-gray-800 leading-none ">
            {trends?.[item.key]?.min?.value}
          </span>
        </div>

        <span className="mt-1 text-xs text-gray-400">{trends?.[item.key]?.min?.date}</span>
      </Flex>

      <div className="w-px h-14 bg-gray-100" />

      <div className="flex flex-col items-end">
        <span className="text-xs text-gray-400">{trendBundle.maxUsage[lang]}</span>

        <span className="text-lg font-bold text-gray-800 leading-none tabular-nums">
          {trends?.[item.key]?.max?.value}
        </span>

        <span className="mt-1 text-xs text-gray-400">{trends?.[item.key]?.max?.date}</span>
      </div>
    </div>
  )
}

const Mobile = ({ trends, item }) => {
  return (
    <div className="flex gap-1 items-end justify-between">
      <Flex className="flex-col w-17 h-20 justify-end text-right" gap={2}>
        <span className="text-xs text-gray-400">{trendBundle.minUsage.en}</span>

        <span className="text-[17px] font-bold text-gray-800 leading-none">
          {trends?.[item.key]?.min?.value}
        </span>

        <span className="mt-1 text-xs text-gray-400">{trends?.[item.key]?.min?.date}</span>
      </Flex>

      <Flex className="flex-col w-17 h-20 justify-end text-right" gap={2}>
        <span className="text-xs text-gray-400">{trendBundle.maxUsage.en}</span>

        <span className="text-[17px] font-bold text-gray-800 leading-none">
          {trends?.[item.key]?.max?.value}
        </span>

        <span className="mt-1 text-xs text-gray-400">{trends?.[item.key]?.max?.date}</span>
      </Flex>
    </div>
  )
}

const ResourceTrendMinMax = ({ trends, item }) => {
  const { lang } = langStore()
  const isMobile = useIsMobile()

  return isMobile ? (
    <Mobile trends={trends} item={item} />
  ) : (
    <Desktop trends={trends} item={item} lang={lang} />
  )
}

export default ResourceTrendMinMax
